var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgManageProfileContactInfo = function SvgManageProfileContactInfo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 38.31 36.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".manageprofile-contact-1,.manageprofile-contact-5{fill:#353535;}.manageprofile-contact-1,.manageprofile-contact-2,.manageprofile-contact-3,.manageprofile-contact-4{fill-rule:evenodd;}.manageprofile-contact-2{fill:current;}.manageprofile-contact-3{fill:#fff;}.manageprofile-contact-4{fill:url(#radial-gradient-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -288.04,
    cy: 363.25,
    r: 1,
    gradientTransform: "matrix(72.34, 55.5, 75.84, -98.86, -6718.98, 51888.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f11e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10015"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -277.89,
    cy: 360.74,
    r: 1,
    gradientTransform: "matrix(26.15, 13.68, 29.74, -56.86, -3443.3, 24342.87)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-1",
    d: "M10.48,4.05h9.21l-.75-1.81A1.64,1.64,0,0,0,17.48,1H11.12a1.21,1.21,0,0,0-1.21,1.2v.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-2",
    d: "M18.94,4.05H10.48L9.91,2.69l-.18-.45C9.35,1.35,8.83,1,8.31,1H1.9A1.2,1.2,0,0,0,.7,2.24V26.91a1.2,1.2,0,0,0,1.2,1.2H25.77a3.89,3.89,0,0,1-.36-1.63v-2a3.92,3.92,0,0,1,7.84,0v2a3.88,3.88,0,0,1-.35,1.63h3.6a1.2,1.2,0,0,0,1.2-1.2V5.25a1.2,1.2,0,0,0-1.2-1.2Zm-5.3,6H24.77A1.21,1.21,0,0,1,26,11.27v6.61a1.21,1.21,0,0,1-1.2,1.21H13.64a1.21,1.21,0,0,1-1.21-1.21V11.27A1.21,1.21,0,0,1,13.64,10.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-3",
    d: "M24.77,10.06H13.64a1.21,1.21,0,0,0-1.21,1.21v6.61a1.21,1.21,0,0,0,1.21,1.21H24.77A1.21,1.21,0,0,0,26,17.88V11.27A1.21,1.21,0,0,0,24.77,10.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-1",
    d: "M29.33,20.59a3.93,3.93,0,0,0-3.92,3.92c1.49,1,3.74,0,4.89-.84a2.71,2.71,0,0,0,2.95.84,3.93,3.93,0,0,0-3.92-3.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-3",
    d: "M30.3,23.67c-1.15.82-3.4,1.8-4.89.84v2a3.89,3.89,0,0,0,.36,1.63,4,4,0,0,0,.86,1.21,3.91,3.91,0,0,0,5.4,0,4,4,0,0,0,.87-1.21,3.88,3.88,0,0,0,.35-1.63v-2a2.71,2.71,0,0,1-2.95-.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-4",
    d: "M32,29.32a3.91,3.91,0,0,1-5.4,0,6.87,6.87,0,0,0-4.17,6.31H36.2A6.87,6.87,0,0,0,32,29.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-5",
    d: "M17.2,17.16h0a.75.75,0,0,0,0-1.5h0a.75.75,0,0,0,0,1.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-5",
    d: "M24,15.36H20.9a.75.75,0,1,0,0,1.5H24a.75.75,0,1,0,0-1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "manageprofile-contact-5",
    d: "M18.71,13.85H24a.76.76,0,1,0,0-1.51H18.71a.76.76,0,0,0,0,1.51Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManageProfileContactInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ManageProfileContactInfo.fe8afdf9.svg";
export { ForwardRef as ReactComponent };